import React from 'react';
import { Document } from 'components/Pdf/document';
import { Page } from 'components/Pdf/page';
import * as pdfjsLib from 'pdfjs-dist';
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/${pdfjsLib.version}.pdf.worker.min.js`;
interface Props {
  pageNumber: number;
  docImage: string;
  pageRotation: number;
}

function Preview(props: Props) {
  const { docImage, pageNumber, pageRotation } = props;

  return docImage && pageNumber ? (
    <Document
      file={`data:application/pdf;base64, ${docImage}`}
      onLoadError={console.error}
      options={{
        cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjsLib.version}/cmaps/`,
        cMapPacked: true,
      }}
    >
      <Page
        rotate={pageRotation}
        height={null}
        width={null}
        scale={0.8}
        pageNumber={pageNumber}
      />
    </Document>
  ) : null;
}

export default Preview;
